(() => {
  if (window.VidtoutOffersCarousel) return;

  const MOBILE_MQ = window.matchMedia('(max-width: 749px)');

  /** @param {Event} event */
  function blockDisabledNavClick(event) {
    if (!(event.target instanceof Element)) return;

    const disabledControl = event.target.closest('.vidtout-glass-chevron:disabled');
    if (!disabledControl) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
  }

  /** @param {HTMLElement} scroller */
  function getScrollStep(scroller) {
    const item = scroller.querySelector('.product-grid__item, .resource-list__item');
    if (!(item instanceof HTMLElement)) return scroller.clientWidth;
    const gap = parseFloat(getComputedStyle(scroller).columnGap || getComputedStyle(scroller).gap) || 0;
    return item.offsetWidth + gap;
  }

  /**
   * @param {HTMLElement} scroller
   * @param {number} direction
   */
  function scrollCarousel(scroller, direction) {
    scroller.scrollBy({ left: getScrollStep(scroller) * direction, behavior: 'smooth' });
  }

  /**
   * @param {Event} event
   * @param {HTMLElement} scroller
   * @param {number} direction
   */
  function handleNavClick(event, scroller, direction) {
    const button = event.currentTarget;
    if (!(button instanceof HTMLButtonElement) || button.disabled) {
      blockDisabledNavClick(event);
      return;
    }
    scrollCarousel(scroller, direction);
  }

  /**
   * @param {HTMLElement} wrapper
   * @param {HTMLElement} scroller
   */
  function updateButtons(wrapper, scroller) {
    const prev = wrapper.querySelector('[data-vidtout-carousel-prev]');
    const next = wrapper.querySelector('[data-vidtout-carousel-next]');
    if (!(prev instanceof HTMLButtonElement) || !(next instanceof HTMLButtonElement)) return;

    const maxScroll = scroller.scrollWidth - scroller.clientWidth;
    prev.disabled = scroller.scrollLeft <= 2;
    next.disabled = scroller.scrollLeft >= maxScroll - 2;
  }

  /** @param {HTMLElement} wrapper */
  function initWrapper(wrapper) {
    if (wrapper.dataset.vidtoutCarouselReady) return;

    const scroller = wrapper.querySelector(
      '.vidtout-mobile-carousel-track, .product-grid--vidtout, .vidtout-offers-carousel__track'
    );
    if (!(scroller instanceof HTMLElement)) return;

    const prev = wrapper.querySelector('[data-vidtout-carousel-prev]');
    const next = wrapper.querySelector('[data-vidtout-carousel-next]');

    prev?.addEventListener('click', (e) => handleNavClick(e, scroller, -1));
    next?.addEventListener('click', (e) => handleNavClick(e, scroller, 1));

    const onScroll = () => updateButtons(wrapper, scroller);
    scroller.addEventListener('scroll', onScroll, { passive: true });

    const observer = new MutationObserver(onScroll);
    observer.observe(scroller, { childList: true });

    wrapper.dataset.vidtoutCarouselReady = 'true';
    scroller.scrollLeft = 0;
    onScroll();
  }

  function initAll() {
    document.querySelectorAll('[data-vidtout-grid-carousel]').forEach((wrapper) => {
      if (wrapper instanceof HTMLElement) initWrapper(wrapper);
    });
  }

  document.addEventListener('click', blockDisabledNavClick, true);
  document.addEventListener('pointerdown', blockDisabledNavClick, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
  MOBILE_MQ.addEventListener('change', () => {
    document.querySelectorAll('[data-vidtout-grid-carousel]').forEach((el) => {
      if (!(el instanceof HTMLElement)) return;
      delete el.dataset.vidtoutCarouselReady;
    });
    initAll();
  });

  window.VidtoutOffersCarousel = { initAll, initWrapper };
})();
